export default __webpack_public_path__ + "static/media/logoNewYorkTimes.27eb83bf.png";